"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const appConstants_1 = require("../../../../constants/appConstants");
const strings_1 = require("../../../../constants/strings");
const uiConstants_1 = require("../../../../constants/uiConstants");
const zustandStore_1 = require("../../../../zustandStore");
const simpleButton_1 = __importDefault(require("../../../atoms/button/simpleButton"));
const ConfirmAsides = ({ openMultiUseAside, setOpenMultiUseAside, openSingleUseAside, setOpenSingleUseAside, openSubscriptionAside, setOpenSubscriptionAside, }) => {
    const { team, setTeam } = (0, zustandStore_1.useZustand)(state => ({
        team: state.team.team,
        setTeam: state.setTeam,
    }));
    const confirmAsideSettings = [
        {
            asideId: appConstants_1.teamFeaturesConstants.enableMutiUseVirtualCard,
            openConfirm: openMultiUseAside,
            setOpenConfirm: setOpenMultiUseAside,
            note: strings_1.teamSettingsOverviewStrings.CONFIRM_MULTI_USE_ACTION_CONTENT,
            feature: appConstants_1.teamFeaturesConstants.enableMutiUseVirtualCard,
        },
        {
            asideId: appConstants_1.teamFeaturesConstants.enableSingleUseVirtualCard,
            openConfirm: openSingleUseAside,
            setOpenConfirm: setOpenSingleUseAside,
            note: strings_1.teamSettingsOverviewStrings.CONFIRM_SINGLE_USE_ACTION_CONTENT,
            feature: appConstants_1.teamFeaturesConstants.enableSingleUseVirtualCard,
        },
        {
            asideId: appConstants_1.teamFeaturesConstants.enableSubscriptionVirtualCard,
            openConfirm: openSubscriptionAside,
            setOpenConfirm: setOpenSubscriptionAside,
            note: strings_1.teamSettingsOverviewStrings.CONFIRM_SUBSCRIPTION_ACTION_CONTENT,
            feature: appConstants_1.teamFeaturesConstants.enableSubscriptionVirtualCard,
        },
    ];
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: confirmAsideSettings.map(setting => ((0, jsx_runtime_1.jsxs)(material_1.Dialog, { open: setting.openConfirm, onClose: () => {
                setting.setOpenConfirm(false);
            }, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", children: [(0, jsx_runtime_1.jsx)(material_1.DialogTitle, { id: "alert-dialog-title", sx: { padding: 1 }, children: strings_1.teamSettingsOverviewStrings.CONFIRM_ACTION_TITLE }), (0, jsx_runtime_1.jsx)(material_1.DialogContent, { sx: { padding: 0 }, children: (0, jsx_runtime_1.jsx)(material_1.DialogContentText, { id: "alert-dialog-description", children: (0, jsx_runtime_1.jsx)(material_1.Alert, { severity: "warning", children: setting.note }) }) }), (0, jsx_runtime_1.jsxs)(material_1.DialogActions, { children: [(0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "yes-btn", onClick: () => {
                                if (!team) {
                                    return;
                                }
                                setTeam({
                                    ...team,
                                    properties: {
                                        ...team.properties,
                                        [setting.feature]: 'false',
                                    },
                                });
                                setting.setOpenConfirm(false);
                            }, label: strings_1.companySettingsTeamsStrings.YES_BUTTON_TEXT, style: { width: '20%' } }), (0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "cancel-btn", onClick: () => {
                                setting.setOpenConfirm(false);
                            }, color: uiConstants_1.UI_BUTTON_SECONDARY, label: strings_1.companySettingsTeamsStrings.CANCEL_BUTTON_TEXT })] })] }, setting.asideId))) }));
};
exports.default = ConfirmAsides;
